export default __webpack_public_path__ + "static/media/MudaMuda.58436122.mp3";